//Chris Solinsky
//UsersPage.js
// An admin management page for controlling a user information, profile, stats
import { useState, useEffect } from 'react';
import { API } from '../utils/axiosConfig';
import {
	Container,
	Card,
	FormControl,
	InputGroup,
	Button,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faEdit,
	faSearch,
	faUser,
	faXmark,
} from '@fortawesome/free-solid-svg-icons';

const UsersPage = () => {
	const api = API();
	const [users, setUsers] = useState([]);
	const [filteredUsers, setFilteredUsers] = useState([]);
	const [selectedUser, setSelectedUser] = useState();
	const [searchValue, setSearchValue] = useState('');

	useEffect(() => {
		getUsers();
	}, []);
	useEffect(() => {
		setFilteredUsers(users);
	}, [users]);
	useEffect(() => {
		filterUsers();
	}, [searchValue]);

	const getUsers = () => {
		api
			.get('/users/getAllUsers')
			.then((res) => {
				if (res.status === 200) {
					console.log(res.data.users);
					setUsers(res.data.users);
				}
			})
			.catch((err) => console.log(err));
	};

	const filterUsers = (e) => {
		let names = users.filter((user) => {
			let regex = new RegExp(searchValue, 'gi');
			let value = regex.test(user.firstName + ' ' + user.lastName);
			return value;
		});
		setFilteredUsers(names);
	};

	return (
		<div className="page">
			<Container>
				<Card>
					<Card.Header>
						<h5>
							<FontAwesomeIcon icon={faUser} /> Clients
						</h5>
					</Card.Header>
					<Card.Body>
						<InputGroup>
							<InputGroup.Text>
								<FontAwesomeIcon icon={faSearch} />
							</InputGroup.Text>
							<FormControl
								type="text"
								name="searchbar"
								onChange={(e) => setSearchValue(e.target.value)}
								value={searchValue}
							/>
							<InputGroup.Text>
								<FontAwesomeIcon
									icon={faXmark}
									onClick={() => setSearchValue('')}
									style={{ cursor: 'pointer' }}
								/>
							</InputGroup.Text>
						</InputGroup>
						{filteredUsers.map((user, i) => {
							return (
								<div key={i} className="d-flex align-items-center">
									<div>
										{user.firstName} {user.lastName}
									</div>
									<FontAwesomeIcon
										icon={faEdit}
										onClick={() => setSelectedUser(user)}
										style={{ cursor: 'pointer' }}
									/>
								</div>
							);
						})}
					</Card.Body>
				</Card>

				{selectedUser && (
					<>
						<hr />
						<Card>
							<Card.Header>Selected User:</Card.Header>
							<Card.Body>
								<h5>
									{selectedUser.firstName} {selectedUser.lastName}
								</h5>
								{selectedUser.address && <label>Address:</label>}
								<div>{selectedUser.address}</div>
								{selectedUser.city &&
									selectedUser.state &&
									selectedUser.zipcode && (
										<div>
											{selectedUser.city}, {selectedUser.state}{' '}
											{selectedUser.zipcode}
										</div>
									)}
								<br />
								{selectedUser.email && (
									<div>
										<a href={`mailto:${selectedUser.email}`}>
											{selectedUser.email}
										</a>
									</div>
								)}
							</Card.Body>
						</Card>
					</>
				)}
			</Container>
		</div>
	);
};
export default UsersPage;
